import Raven from 'raven-js'
import { createFetch, accept, header, init, debug, recv } from 'http-client'

export default (url, options = {}) => {
  const request = createFetch(
    accept('application/json'),
    header('x-requested-with', 'fetch'),
    header('content-type', 'application/json'),
    init('credentials', options.credentials || 'include'),
    debug(),
    recv(response => {
      if (response.debug) {
        response.requestInfo = sanitizeDebugInfo(response.debug)
        delete response.debug
      }

      return response
    })
  )

  return request(url, options).catch(err => {
    const fullStoryURL = getFullStory()
    let requestInfo

    if (err.debug) {
      requestInfo = sanitizeDebugInfo(err.debug)
      err.requestInfo = requestInfo
      delete err.debug
    }

    Raven.setExtraContext({
      fullStoryURL,
      requestInfo
    })

    throw err
  })
}

function getFullStory() {
  if (!window.FS || typeof window.FS.getCurrentSessionURL !== 'function') {
    return
  }

  return window.FS.getCurrentSessionURL(true)
}

function sanitizeDebugInfo(debugInfo) {
  const sanitized = {
    input: debugInfo.input,
    method: debugInfo.options.method
  }

  // We only care about grabbing the `operationName`, which gives us enough insight into the call site
  if (debugInfo.input === '/api/graphql') {
    const body = JSON.parse(debugInfo.options.body)
    sanitized.operationName = body.operationName
  }

  return sanitized
}
